'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as ToastPrimitive from '@radix-ui/react-toast';
import clsx from 'clsx';
import { forwardRef, useId, } from 'react';
import { Elevator } from '../../index.js';
import { InlineToast } from './inline-toast.js';
import styles from './toast.module.css';
export const Toast = forwardRef(({ children, open, defaultOpen, type, duration, forceMount, onOpenChange, ...otherProps }, forwardedRef) => {
    const uid = useId();
    return (_jsx(ToastPrimitive.Root, { asChild: true, ref: forwardedRef, open: open, type: type, duration: duration, forceMount: forceMount, onOpenChange: onOpenChange, defaultOpen: defaultOpen, children: _jsx("li", { className: styles.ToastRoot, children: _jsx(Elevator, { resting: 4, children: _jsx(InlineToast, { isPrimitive: true, ...otherProps, children: children }) }) }, `${uid}-toast`) }));
});
export const ToastViewport = ({ className, ...otherProps }) => (_jsx(ToastPrimitive.Viewport, { className: clsx(styles.Viewport, className), ...otherProps }));
export const { ToastProvider } = ToastPrimitive;
